module.exports = {
          srcSet: __webpack_public_path__ + "b05a5762.jpg"+" 696w",
          images:[ {path: __webpack_public_path__ + "b05a5762.jpg",width: 696,height: 566}],
          src: __webpack_public_path__ + "b05a5762.jpg",
          toString:function(){return __webpack_public_path__ + "b05a5762.jpg"},
          
          width: 696,
          height: 566
        }